import { Formik } from 'formik';
import InputForm from '../../commun/input-form';
import { Button, Grid, Stack, Switch, Typography } from '@mui/material';
import React from 'react';
import './search-user.form.scss';
import { SearchUserFormDto } from '../../../services/dtos/form/search-user-form.dto';

/**
 * Moteur de recherche des abonnés
 * @param props props
 * @constructor
 */
export default function SearchUserForm(props: {
    handleSumbitForm: (values: any) => void;
    handleChangeSwitch: () => void;
    searching: boolean;
    showSearchUser: boolean;
}) {
    //Init values
    const iniValues: SearchUserFormDto = {
        identifier: '',
        birthName: '',
        name: '',
        firstName: '',
        billNumber: '',
        contractNumber: '',
    };

    return (
        //Init du formulaire
        <Formik initialValues={iniValues} onSubmit={props.handleSumbitForm}>
            {propsForm => (
                //On passe les handlers ou autre utile au form
                <form onReset={propsForm.handleReset} onSubmit={propsForm.handleSubmit}>
                    {/*Mise en place du switch*/}
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ marginBottom: '15px' }}>
                        {/*Recherche par données abonné*/}
                        <Typography variant="body1">
                            <Typography component="span" sx={{ fontWeight: 'bold' }}>
                                Recherche :{' '}
                            </Typography>
                            Par abonné
                        </Typography>
                        <Switch
                            data-testid="switch-info"
                            onChange={() => {
                                props.handleChangeSwitch();
                                propsForm.resetForm();
                            }}
                        />
                        {/*recherche par données contrat*/}
                        <Typography>Par contrat</Typography>
                    </Stack>
                    <Grid container spacing={2} className="search-user-form">
                        {props.showSearchUser ? (
                            <>
                                {/*Mise en place des champs de recherche*/}
                                <Grid item xs={12} sm={3}>
                                    {/*identifiant*/}
                                    <InputForm id="identifier" name="identifier" label="Identifiant" />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    {/*nom de naissance*/}
                                    <InputForm id="birthName" name="birthName" label="Nom de naissance" />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    {/*nom d'usage*/}
                                    <InputForm id="name" name="name" label="Nom d'usage" />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    {/*prénom*/}
                                    <InputForm id="firstName" name="firstName" label="Prénom" />
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item xs={12} sm={3}>
                                    {/*numéro de facture*/}
                                    <InputForm id="billNumber" name="billNumber" label="Numéro de facture" />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    {/*numéro de contrat*/}
                                    <InputForm id="contractNumber" name="contractNumber" label="Numéro de contrat" />
                                </Grid>
                            </>
                        )}
                        <Grid item xs={0} sm={9}></Grid>
                        <Grid item xs={12} sm={3}>
                            {/*Gestion des boutons*/}
                            <Typography variant={'button'} className={'buttons-form'}>
                                <Button variant="neutral" type="reset">
                                    Réinitialiser
                                </Button>
                                {/*Bouton valider, désactivé durant le traitement du formulaire*/}
                                <Button type="submit" variant="contained" disabled={props.searching}>
                                    Rechercher
                                </Button>
                            </Typography>
                        </Grid>
                    </Grid>
                </form>
            )}
        </Formik>
    );
}
